import { render, staticRenderFns } from "./vue-gecode.vue?vue&type=template&id=5ef7fd8b&"
import script from "./vue-gecode.vue?vue&type=script&lang=js&"
export * from "./vue-gecode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.4.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\other\\tsTest\\vue-gecode\\node_modules\\_vue-hot-reload-api@2.3.0@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5ef7fd8b', component.options)
    } else {
      api.reload('5ef7fd8b', component.options)
    }
    module.hot.accept("./vue-gecode.vue?vue&type=template&id=5ef7fd8b&", function () {
      api.rerender('5ef7fd8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue-gecode.vue"
export default component.exports